import { emptySplitApi } from "./empty-split-api";

export interface StaffAssignmentUser {
  user_id: number;
  first_name: string;
  last_name: string;
  role: string;
}

export interface ClinicStaffScheduleResponse {
  clinic_id: number;
  assignments: Record<string, StaffAssignmentUser[]>;
}

export interface ClinicStaffScheduleRequest {
  clinicId: number;
  assignments: Record<string, number[]>;
}

export interface DefaultStaffResponse {
  default_staff_ids: number[] | null;
}

export const clinicStaffScheduleApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getClinicStaffSchedule: builder.query<ClinicStaffScheduleResponse, number>({
      query: (clinicId) => `/clinics/${clinicId}/staff-schedule/`,
      providesTags: (result, error, clinicId) => [
        { type: "ClinicStaffSchedule", id: clinicId }
      ]
    }),
    updateClinicStaffSchedule: builder.mutation<
      ClinicStaffScheduleResponse,
      ClinicStaffScheduleRequest
    >({
      query: ({ clinicId, assignments }) => ({
        url: `/clinics/${clinicId}/staff-schedule/`,
        method: "PUT",
        body: { assignments }
      }),
      invalidatesTags: (result, error, { clinicId }) => [
        { type: "ClinicStaffSchedule", id: clinicId }
      ]
    }),
    getDefaultStaff: builder.query<
      DefaultStaffResponse,
      { clinicId: number; date: string }
    >({
      query: ({ clinicId, date }) =>
        `/clinics/${clinicId}/default-staff/?date=${date}`,
      providesTags: (result, error, { clinicId }) => [
        { type: "ClinicStaffSchedule", id: clinicId }
      ]
    })
  })
});

export const {
  useGetClinicStaffScheduleQuery,
  useUpdateClinicStaffScheduleMutation,
  useGetDefaultStaffQuery
} = clinicStaffScheduleApi;
